import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import ActionAdditionForm from '../Actions/ActionAdditionForm';
import ExclusionCriteriaSubForm from '../_common/ExclusionCriteriaSubForm';
import { convertAxiosErrorToUserFacingMessage, useApiClient } from '../../context/ApiClientContext';
import basicServiceHandler from '../../services/basicServiceHandler';
import useToast from '../../hooks/useToast';

export default function SxOfDxhxPane({ sxOfDxhxId, actionListId, reloadCallback }) {
  const apiClient = useApiClient();
  const { toastSetErrorNotification } = useToast();

  const [exclusionCriteria, setExclusionCriteria] = useState(null);

  const refresh = () => basicServiceHandler(
    () => apiClient.getSxOfDxhx(sxOfDxhxId),
    (result) => {
      const {
        exclusionCriteria: newExclusionCriteria,
      } = result.data;
      setExclusionCriteria(newExclusionCriteria);
    },
    (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
    () => {},
  );
  useEffect(refresh, [sxOfDxhxId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ExclusionCriteriaSubForm
          onSubmit={(condition) => apiClient.updateSxOfDxhx(
            sxOfDxhxId,
            { exclusionCriteria: condition },
          )}
          exclusionCriteria={exclusionCriteria}
          refreshParent={() => {
            refresh();
            reloadCallback();
          }}
        />
        <Divider sx={{ my: 2 }} />
        <ActionAdditionForm
          actionListId={actionListId}
          reloadCallback={reloadCallback}
        />
      </Grid>
    </Grid>
  );
}

SxOfDxhxPane.propTypes = {
  sxOfDxhxId: PropTypes.number.isRequired,
  actionListId: PropTypes.number.isRequired,
  reloadCallback: PropTypes.func.isRequired,
};
